module.exports = __webpack_public_path__ + "static/img/Christel Heydemann_2017-18.2e1a014.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/leadership/Christel Heydemann_2017-18.jpg
// module id = lL8G
// module chunks = 0